module.exports = __webpack_public_path__ + "img/product_130.dd25c77.webp";